import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '../../api/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IUpdate2FARequest, ISecuritySettingsResponse } from './security.model';
import { IGetAdminAlertsRes } from '../../../_models/notification.model';
import { IAppResponse } from '../../../_interceptors/network-error.model';

@Injectable({
  providedIn: 'root'
})
export class AdminSecurityService {

  private unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$ = this.unreadCountSubject.asObservable();

  constructor(private apiService: ApiService) { }

  setUnreadCount(count: number): void {
    this.unreadCountSubject.next(count);
  }

  incrementUnreadCount(): void {
    this.unreadCountSubject.next(this.unreadCountSubject.getValue() + 1);
  }

  resetUnreadCount(): void {
    this.unreadCountSubject.next(0);
  }

  decrementUnreadCount(): void {
    const current = this.unreadCountSubject.getValue();
    this.unreadCountSubject.next(Math.max(0, current - 1));
  }

  getSecuritySettings(): Observable<any> {
    return this.apiService.get<ISecuritySettingsResponse>({
      Url: 'dating/admin/security'
    });
  }

  update2FASettings(payload: IUpdate2FARequest): Observable<any> {
    return this.apiService.put<IUpdate2FARequest, any>({
      Url: 'dating/admin/security/2fa',
      Body: payload
    });
  }

  revokeSession(sessionId: string): Observable<any> {
    return this.apiService.delete<any, any>({
      Url: `dating/admin/security/sessions/${sessionId}`
    });
  }

  getAdminAlerts(page: number = 1, limit: number = 20): Observable<IAppResponse<IGetAdminAlertsRes>> {
    return this.apiService.get<IGetAdminAlertsRes>({
      Url: 'dating/admin/security/alerts',
      Params: new HttpParams({ fromObject: { page: String(page), limit: String(limit) } })
    });
  }

  markAlertsRead(alertIds?: string[]): Observable<IAppResponse<{ message: string }>> {
    return this.apiService.post<{ alertIds?: string[] }, { message: string }>({
      Url: 'dating/admin/security/alerts/read',
      Body: { alertIds }
    });
  }
}
